import React, { useEffect, useMemo, useState } from 'react';

import Sidebar from '../../components/Sidebar';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { config } from '../../utills';
import { useNavigate } from 'react-router-dom';
import { MainBox, UserName, Count } from '../Elements';
import { getFullName } from '../../utills/constants';
import { useSelector, useDispatch } from 'react-redux';
import { GreenText, NameSpan } from '../Profile/Private/Elements';
import { useMediaQuery, List, Avatar } from '@mui/material';
import { getFunction } from '../../features/auth/action';
import { Back, FormBox, CustomListItem, FormBoxA } from './Elements';
import { stopLoading, startLoading } from '../../features/auth/reducer';
import toast from 'react-hot-toast';
import api from '../../api';
import CustomSwitch from '../../components/Button/Switch';
import FullPageLoader from '../../components/common/FullPageLoader';

const EmailManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const matches600 = useMediaQuery('(max-width:600px)');
  const { userInfo } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  const [enable, setEnable] = useState({
    userId: userInfo?._id,
    isProfileEmail: false,
    isTripEmail: false,
    isMessagesEmail: false,
    isExpiringEmail: false,
  });

  const handleEnable = async (value) => {
    try {
      setLoading(true);
      const res = await api.post('/emailsetting', { ...enable, [value]: !enable[value] });
      setEnable(res.data.data);
      toast.success('Email setting updated successfully');
    } catch (error) {
      console.log('error in handleEnable for email setting', error);
      toast.error(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const emailOptions = useMemo(
    () => [
      { title: 'Profile changes', value: 'isProfileEmail' },
      { title: 'Trip offers', value: 'isTripEmail' },
      { title: 'Messages', value: 'isMessagesEmail' },
      { title: 'Expiring Trips', value: 'isExpiringEmail' },
    ],
    []
  );

  const getEmailSettings = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/emailsetting?userId=${userInfo?._id}`);
      const [emailSetting] = response.data.data;
      setEnable(emailSetting);
    } catch (error) {
      console.log('error in getEmailSettings for email setting', error);
      // toast.error(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEmailSettings();
  }, []);

  return (
    <MainBox sx={{ marginTop: matches600 ? 6 : 0 }}>
      <Sidebar />
      <FormBox>
        <FormBoxA sx={{ height: 'max-content' }}>
          <div style={{ position: 'relative' }}>
            <FullPageLoader isLoading={loading} width="80" />
            <Back sx={{ ml: 1, mt: 1 }} onClick={() => navigate('/settings')}>
              <ChevronLeftIcon sx={{ fontSize: 'medium' }} />
              Back to Settings
            </Back>
            <UserName sx={{ fontSize: '18px', ml: 2, mb: 3, mt: 1 }}>Email Managment</UserName>
            <Count sx={{ ml: 2 }}>Enable or Disabled Preference Emails</Count>
            <List>
              {emailOptions?.map((res) => {
                return (
                  <CustomListItem key={res.value}>
                    <NameSpan>{res?.title}</NameSpan>
                    <CustomSwitch
                      handleToggle={() => handleEnable(res.value)}
                      checked={enable[res.value]}
                    />
                  </CustomListItem>
                );
              })}
            </List>
          </div>
        </FormBoxA>
      </FormBox>
    </MainBox>
  );
};
export default EmailManagement;
